module.exports = __webpack_public_path__ + "static/media/baywheels-logo.2e921fe7.svg";